module.exports = __webpack_public_path__ + "img/banner.c9257e92.jpg";